import {NEUTRAL_PLAYER_COLOR} from "../../../constants/players";

/**
 * Цвет исходного владельца юнита, если он был захвачен соблазнением
 * (см. unit.capturedFromOwnerId, редьюсер-кейс FACTION_SUCCUBES_SEDUCE_UNIT) -
 * используется для отрисовки половины силуэта другим цветом (design.md
 * Decision 14). Возвращает null, если юнит не был захвачен.
 *
 * Определяется по capturedFromOwnerId (ID РЕАЛЬНОГО предыдущего владельца), а
 * НЕ по сравнению unit.factionId с factionId текущего владельца: сравнение по
 * factionId ложно считало захваченными юнитов сюжетной кампании, у которых
 * factionId вовсе не проставлен (см. ревью, дефект №2), и не могло однозначно
 * определить исходного владельца, если несколько игроков играют за одну
 * фракцию (дефект №13, например зеркальный матч Суккубов).
 * @param {Object} unit - юнит
 * @param {Array} players - все игроки
 * @returns {string|null} цвет исходного владельца, либо NEUTRAL_PLAYER_COLOR,
 *   если юнит был захвачен у нейтрала, либо null, если юнит не захвачен
 */
export const getCapturedUnitOriginalColor = (unit, players) => {
  if (unit.capturedFromOwnerId == null) {
    return null;
  }
  const originalPlayer = players.find(p => p.id === unit.capturedFromOwnerId);
  return originalPlayer?.color ?? NEUTRAL_PLAYER_COLOR;
};
